import React from "react";
import { usePublisherPublicCatalogLink } from "../hooks/usePublisherPublicCatalogLink";
import { PublicCatalogLink } from "./PublicCatalogLink";
/** "Zobrazit ve veřejném katalogu" for a publisher (DB-801), see {@link PublicCatalogLink}. */
export var PublisherPublicCatalogLink = function (_a) {
    var publisherId = _a.publisherId;
    var record = usePublisherPublicCatalogLink(publisherId);
    return (React.createElement(PublicCatalogLink, { record: record, notPublicMessageId: "ui-br-publishers.publicCatalog.publisher.notPublic" }));
};
